__turbopack_context__.v({
  "achievements": "experience-section-module-scss-module__3EV7pq__achievements",
  "backDesc": "experience-section-module-scss-module__3EV7pq__backDesc",
  "backDescScroll": "experience-section-module-scss-module__3EV7pq__backDescScroll",
  "backDot": "experience-section-module-scss-module__3EV7pq__backDot",
  "backDots": "experience-section-module-scss-module__3EV7pq__backDots",
  "backTitle": "experience-section-module-scss-module__3EV7pq__backTitle",
  "backTitleLine": "experience-section-module-scss-module__3EV7pq__backTitleLine",
  "backTitleWrap": "experience-section-module-scss-module__3EV7pq__backTitleWrap",
  "cardBack": "experience-section-module-scss-module__3EV7pq__cardBack",
  "cardBackBg": "experience-section-module-scss-module__3EV7pq__cardBackBg",
  "cardBackContent": "experience-section-module-scss-module__3EV7pq__cardBackContent",
  "cardBackGlow": "experience-section-module-scss-module__3EV7pq__cardBackGlow",
  "cardContent": "experience-section-module-scss-module__3EV7pq__cardContent",
  "cardCorner": "experience-section-module-scss-module__3EV7pq__cardCorner",
  "cardFront": "experience-section-module-scss-module__3EV7pq__cardFront",
  "cardGlow": "experience-section-module-scss-module__3EV7pq__cardGlow",
  "cardHover": "experience-section-module-scss-module__3EV7pq__cardHover",
  "company": "experience-section-module-scss-module__3EV7pq__company",
  "container": "experience-section-module-scss-module__3EV7pq__container",
  "ctaBg": "experience-section-module-scss-module__3EV7pq__ctaBg",
  "ctaBlock": "experience-section-module-scss-module__3EV7pq__ctaBlock",
  "ctaButton": "experience-section-module-scss-module__3EV7pq__ctaButton",
  "ctaGradient": "experience-section-module-scss-module__3EV7pq__ctaGradient",
  "ctaInner": "experience-section-module-scss-module__3EV7pq__ctaInner",
  "ctaSubtitle": "experience-section-module-scss-module__3EV7pq__ctaSubtitle",
  "ctaTitle": "experience-section-module-scss-module__3EV7pq__ctaTitle",
  "desc": "experience-section-module-scss-module__3EV7pq__desc",
  "experienceDotPing": "experience-section-module-scss-module__3EV7pq__experienceDotPing",
  "experienceDotPulse": "experience-section-module-scss-module__3EV7pq__experienceDotPulse",
  "flipInner": "experience-section-module-scss-module__3EV7pq__flipInner",
  "flipWrap": "experience-section-module-scss-module__3EV7pq__flipWrap",
  "hint": "experience-section-module-scss-module__3EV7pq__hint",
  "item": "experience-section-module-scss-module__3EV7pq__item",
  "items": "experience-section-module-scss-module__3EV7pq__items",
  "line": "experience-section-module-scss-module__3EV7pq__line",
  "role": "experience-section-module-scss-module__3EV7pq__role",
  "section": "experience-section-module-scss-module__3EV7pq__section",
  "subtitle": "experience-section-module-scss-module__3EV7pq__subtitle",
  "timeline": "experience-section-module-scss-module__3EV7pq__timeline",
  "timelineDot": "experience-section-module-scss-module__3EV7pq__timelineDot",
  "timelineDotInner": "experience-section-module-scss-module__3EV7pq__timelineDotInner",
  "title": "experience-section-module-scss-module__3EV7pq__title",
  "titleBlock": "experience-section-module-scss-module__3EV7pq__titleBlock",
  "titleLine": "experience-section-module-scss-module__3EV7pq__titleLine",
  "yearBadge": "experience-section-module-scss-module__3EV7pq__yearBadge",
});
